import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link, useSearchParams  } from 'react-router-dom';
import { getGenericStatus } from '../../utils/statusHelper';
import { formatDate } from '../../utils/helper';
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Button, Form } from 'react-bootstrap';

const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [pagination, setPagination] = useState({});
  
    const [searchParams] = useSearchParams();
    
    const [apiData, setApiData] = useState({
        search: "",
        page: 1,
    });

    useEffect(() => {
        getCustomers();
    }, [apiData.page, apiData.search]); 

    const getCustomers = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "admin/customers", 
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setCustomers(data.data.customers || []); 
                setPagination(data.data.pagination || {});
            }
        } catch (error) {
            console.error(error);
            // toast.error("Failed to fetch customers");
        } finally {
            setIsLoader(false);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await ApiService.request({
                        method: "DELETE",
                        url: `admin/customers/${id}`
                    });
                    if (response.data.status) {
                        toast.success(response.data.message);
                        getCustomers();
                    } else {
                        toast.error(response.data.message);
                    }
                } catch (error) {
                    toast.error(error.response?.data?.message || "Failed to delete customer");
                }
            }
        });
    };

    const toggleCustomerStatus = async (customer) => {
        try {
            const response = await ApiService.request({
                method: "PUT",
                url: `admin/customers/${customer.id}`,
                data: {
                    is_active: !customer.is_active,
                },
            });
            if (response.data.status) {
                toast.success(response.data.message || "Status updated");
                getCustomers();
            } else {
                toast.error(response.data.message || "Failed to update status");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to update status");
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            Customer List
                        </h1>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to="/customers/create" className="btn btn-sm fw-bold btn-base">
                            Add Customer
                        </Link>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <div className="d-flex align-items-center position-relative my-1">
                                    <span className="svg-icon svg-icon-1 position-absolute ms-6">
                                        <i className="fas fa-search"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control form-control-solid w-250px ps-14"
                                        placeholder="Search Customer"
                                        value={apiData.search}
                                        onChange={(e) => setApiData({ ...apiData, search: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body py-4">
                            {isLoader ? (
                                <Loader />
                            ) : (
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                                <th className="min-w-125px">Name</th>
                                                <th className="min-w-125px">Email</th>
                                                <th className="min-w-125px">Phone</th>
                                                <th className="min-w-100px">Status</th>
                                                <th className="text-end min-w-100px">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold">
                                            {customers.length > 0 ? (
                                                customers.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>{item.name}</td>
                                                        <td>{item.email}</td>
                                                        <td>{item.phone}</td>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-2">
                                                                {item.is_active ? (
                                                                    <span className="badge badge-light-success">Active</span>
                                                                ) : (
                                                                    <span className="badge badge-light-danger">Inactive</span>
                                                                )}
                                                                <div className="form-check form-switch m-0">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={!!item.is_active}
                                                                        onChange={() => toggleCustomerStatus(item)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="text-end">
                                                            <Link
                                                                to={`/customers/${item.id}`}
                                                                className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                                                title="View"
                                                            >
                                                                <i className="fas fa-eye"></i>
                                                            </Link>
                                                            <Link
                                                                to={`/customers/edit/${item.id}`}
                                                                className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                                                title="Edit"
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </Link>
                                                            <button
                                                                onClick={() => handleDelete(item.id)}
                                                                className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                                                title="Delete"
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        No data found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                             <Paginator
                                pagination={pagination}
                                onPageChange={(page) => setApiData({ ...apiData, page })}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
